import { fetchGraphQL } from 'core/services/graphQLservice'

// getMoveAndReviewDetailsByCustomer(customerID:"${CID}")
export async function getEstimatorPacking(CID: string) {

    var params = `query{
        getEstimatorPacking(customerID:"${CID}")
        {
          materialID
     materialDescription
     qTY
        }
      }
      `;

    var response = await fetchGraphQL('POST', params);
    return response.data.getEstimatorPacking;
}